/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetFeature,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Features List
 */
export const fleetFeatures = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetFeature[]>(
      {url: `/fleets/${fleetSlug}/features`, method: 'GET', signal
    },
      );
    }




export const getFleetFeaturesQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'features'
    ] as const;
    }


export const getFleetFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof fleetFeatures>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetFeatures>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetFeaturesQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetFeatures>>> = ({ signal }) => fleetFeatures(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetFeatures>>, TError, TData>
}

export type FleetFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof fleetFeatures>>>
export type FleetFeaturesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Features List
 */

export function useFleetFeatures<TData = Awaited<ReturnType<typeof fleetFeatures>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetFeaturesQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Disable Fleet Feature
 */
export const disableFleetFeature = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);

      return axiosClient<FleetFeature>(
      {url: `/fleets/${fleetSlug}/features/${id}/disable`, method: 'PUT', signal
    },
      );
    }




export const getDisableFleetFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableFleetFeature>>, TError,{fleetSlug: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disableFleetFeature>>, TError,{fleetSlug: string;id: string}, TContext> => {

const mutationKey = ['disableFleetFeature'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableFleetFeature>>, {fleetSlug: string;id: string}> = (props) => {
          const {fleetSlug,id} = props ?? {};

          return  disableFleetFeature(fleetSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableFleetFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof disableFleetFeature>>>

    export type DisableFleetFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Disable Fleet Feature
 */
export const useDisableFleetFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableFleetFeature>>, TError,{fleetSlug: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disableFleetFeature>>,
        TError,
        {fleetSlug: string;id: string},
        TContext
      > => {
      return useMutation(getDisableFleetFeatureMutationOptions(options), queryClient);
    }
    /**
 * @summary Enable Fleet Feature
 */
export const enableFleetFeature = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);

      return axiosClient<FleetFeature>(
      {url: `/fleets/${fleetSlug}/features/${id}/enable`, method: 'PUT', signal
    },
      );
    }




export const getEnableFleetFeatureMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableFleetFeature>>, TError,{fleetSlug: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enableFleetFeature>>, TError,{fleetSlug: string;id: string}, TContext> => {

const mutationKey = ['enableFleetFeature'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableFleetFeature>>, {fleetSlug: string;id: string}> = (props) => {
          const {fleetSlug,id} = props ?? {};

          return  enableFleetFeature(fleetSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableFleetFeatureMutationResult = NonNullable<Awaited<ReturnType<typeof enableFleetFeature>>>

    export type EnableFleetFeatureMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Enable Fleet Feature
 */
export const useEnableFleetFeature = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableFleetFeature>>, TError,{fleetSlug: string;id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof enableFleetFeature>>,
        TError,
        {fleetSlug: string;id: string},
        TContext
      > => {
      return useMutation(getEnableFleetFeatureMutationOptions(options), queryClient);
    }
